var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NotFoundView flex flex-col"},[_c('div',{staticClass:"m-auto text-center"},[_c('div',{staticClass:"my-12"},[_c('Logo',{staticClass:"mb-4"}),_vm._v("\n      Oops, the page you are looking for doesn't exist\n    ")],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }